export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M16 54 V31 C16 20 23 12.5 32 9.5 C41 12.5 48 20 48 31 V54"
      stroke="#D4AF37"
      strokeWidth="2.4"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    <path d="M11 54 H53" stroke="#D4AF37" strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="32" cy="7.6" r="2.2" fill="#F3E5AB" />
    <path
      d="M32 28 C29.4 31.6 29.4 37 32 41.5 C34.6 37 34.6 31.6 32 28 Z"
      stroke="#F3E5AB"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M32 41.5 C28.2 39.8 24.8 36 25.6 31 C29.4 32 32.4 36.4 32 41.5 Z"
      stroke="#F3E5AB"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      d="M32 41.5 C35.8 39.8 39.2 36 38.4 31 C34.6 32 31.6 36.4 32 41.5 Z"
      stroke="#F3E5AB"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
  </svg>
);

export const Wordmark = ({ compact = false }) => (
  <span className="flex flex-col leading-none">
    <span className="font-display text-[15px] tracking-[0.18em] text-[#F3E5AB]">
      SAI GRAND
    </span>
    {!compact && (
      <span className="font-serif-lux italic text-sm tracking-[0.34em] text-[#D4AF37] mt-1">
        CELEBRATIONS
      </span>
    )}
  </span>
);
